<app-page-breadcrumb pageTitle="Basic Tables" />
<div class="space-y-6">
  <div>
    <app-component-card title="Basic Table 1">
      <app-basic-table-one/>
    </app-component-card>
  </div>

  <div>
    <app-component-card title="Basic Table 2">
      <app-basic-table-two/>
    </app-component-card>
  </div>

  <div>
    <app-component-card title="Basic Table 3">
      <app-basic-table-three/>
    </app-component-card>
  </div>
  
  <div>
    <app-component-card title="Basic Table 4">
      <app-basic-table-four/>
    </app-component-card>
  </div>
  
  <div>
    <app-component-card title="Basic Table 5">
      <app-basic-table-five/>
    </app-component-card>
  </div>
</div>